import { defineComponent as a, useSlots as l, createBlock as s, openBlock as u, h as d, Teleport as f } from "vue";
const _ = /* @__PURE__ */ a({
  inheritAttrs: !1,
  __name: "TeleportCopy",
  props: {
    to: {},
    disabled: { type: Boolean }
  },
  setup(p) {
    const o = p, e = l();
    function c() {
      var r, n;
      const t = (r = e.default) == null ? void 0 : r.call(e, { copy: !1 });
      return t && !o.disabled && o.to && t.push(d(f, { to: o.to }, (n = e.default) == null ? void 0 : n.call(e, { copy: !0 }))), t;
    }
    return (t, r) => (u(), s(c));
  }
});
export {
  _ as default
};
